export function loadUserData(ctx, payload, done) {
    ctx.dispatch('LOAD_USER_DATA', payload);
    done();
}
